<!-- src/App.vue -->
<template>
  <div id="app">
    <NavBar />
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import NavBar from "./components/NavBar.vue";
// import createFloatingImageWorld from "./floatPic.js";

export default {
  components: {
    NavBar
  },
  mounted() {
  // 调用 createFloatingImageWorld 函数
  //createFloatingImageWorld();
},
  name: "App"
};

</script>

<style>
/* 确保导航栏固定在顶部 */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

body {
  margin: 0px;


  overflow-x: hidden; /* 禁用横向滚动 */
}

html {
  overflow-x: hidden; /* 同时在 html 元素上也禁用横向滚动 */
}

#app {
  height: 100vh;
  width: 100%;
  overflow-x: hidden; /* 在 app 容器上也禁用横向滚动 */
  overflow-y: hidden;
}

@media screen and (max-width: 768px) {
  #app {
    height: 100%;
  }
}
/* 滚动条隐藏 */
::-webkit-scrollbar {
  width: 0;
  height: 0;
}
</style>